// dashboard — or. Part of the or i18n bundle; merged by ./index.js

export default {
  back: "Deebi'i",
  createAccount: 'Herrega Uumi',
  creating: 'Herrega uumaa jira...',
  companyNameLabel: 'Maqaa Dhaabbata / Daldala *',
  businessTypeLabel2: 'Gosa Daldala',
  locationLabel: 'Bakka (Magaalaa)',
  websiteLabel: 'Marsariitii (dirqama miti)',
  businessLicenseLabel: 'Lakkoofsa Hayyama Daldala *',
  tinLabel: 'Lakkoofsa TIN',
  elmisLabel: 'Galmee E-LMIS',
  passwordMismatch: 'Jechoonni darbii wal hin simatan.',
  myDashboardTitle: 'Daashboordii Koo',
  underReview: 'Herregni Madaallii Jala Jira',
  underReviewMsg: 'Gareen keenya odeeffannoo daldala kee madaalaa jira. Guyyaa hojii 1-2 keessatti si quunnamna.',
  businessTab: '🏢 Odeeffannoo Daldala',
  socialTab: '📱 Hawaasaa fi Dabalata',
  passwordTab: '🔒 Jecha Darbii',
  saveChanges: 'Jijjiirama Kuusi',
  saving: 'Kuusaa jira...',
  profileUpdated: "Profaayiliin milkaa'inaan haaromfame.",
  passwordChanged: "Jecha darbiin milkaa'inaan jijjiirameera.",
  currentPassword: 'Jecha Darbii Ammaa',
  newPassword: 'Jecha Darbii Haaraa',
  confirmNewPassword: 'Jecha Darbii Haaraa Mirkaneessi',
  confirmPayment: 'Kaffaluu Mirkaneessi',
  rejectPayment: 'Kaffaluu Didu',
  requestDelivery: 'Geejjiba Gaafadhu',
  removedByAdmin: 'Bulchaan Haaqe',
  myStoreTab: '🛍️ Suuqii Koo',
  myOrdersTab: '📦 Ajajoota Koo',
  myPurchasesTab: '🛒 Bitannoota Koo',
  productName: 'Maqaa Oomishaa',
  productDescription: 'Ibsa',
  productPrice: 'Gatii (ETB)',
  productCategory: 'Gosa',
  productStock: "Baay'ina Kuusaa",
  productNotFound: 'Oomishni hin argamne.',
  businessInformation: 'Odeeffannoo Daldala',
  yearEstablished: 'Waggaa Hundeeffame',
  numberOfEmployees: "Baay'ina Hojjataa",
  socialMediaExtra: 'Miidiyaa Hawaasaa fi Dabalata',
  instagramHandle: '📸 Instagram',
  tiktokHandle: '🎵 TikTok',
  telegramLabel: '✈️ Telegraamii',
  facebookPage: '📘 Facebook Fuula',
  servicesNeeded: 'Tajaajila Barbaachisu',
  servicesNeededPlaceholder: 'Fakkeenyaaf: bulchiinsa miidiyaa hawaasaa, uumuun qabiyyee...',
  aboutYourBusiness: 'Waa\'ee Daldala Keessanii',
  aboutYourBusinessPlaceholder: 'Waa\'ee daldala keessanii nuuf ibsaa...',
// Order labels,
  orderNumber: 'Ajaja #',
  bank: 'Baankii',
  proof: 'Ragaa',
  screenshot: 'Suurii',
  ref: 'Wabii',
// Marketplace — hardcoded text localized,
  dashPaymentTab: '💳 Kaffaltii',
  dashEmailInvalid: "Karraa imeelii tolee daqii'aa fudhdoo.",
  dashPhoneInvalid: 'Lakkawwan bilisaa 9 qabaachuu qaba.',
  dashUpdateFailed: "Jijjiirama keenya hin quusunne. Irra deebi'i.",
  dashPasswordChangeFailed: "Jeecha darbii jijjiiruun hin danda'amne. Irra deebi'i.",
  dashFieldRequired: (f) => `${f} galchuun qaba.`,
  dashPriceInvalid: (f) => `${f} kan tokko caalaa ta'uun qaba.`,
  dashStockInvalid: (f) => `${f} kan tokko ol hin taane.`,
  dashSaveProductFailed: "Oomishaa haaromsiisuu hin danda'amne. Meeshaalee hundaa ilaalii.",
  dashDeleteFailed: "Haqiisuu hin danda'amne. Irra deebi'i.",
  dashDeletePhotoFailed: "Suuraa haqiisuu hin danda'amne. Irra deebi'i.",
  dashConfirmFailed: "Kaffaltii mirkaneessuu hin danda'amne. Irra deebi'i.",
  dashRejectFailed: "Kaffaltii diduu hin danda'amne. Irra deebi'i.",
  dashBankAccountRequired: 'Lakkawwan herregaa galchi.',
  dashBankAdded: 'Kaffaltii sifa barreeffamee.',
  dashBankAddFailed: "Kaffaltii sifa dabaluu hin danda'amne. Irra deebi'i.",
  dashSelectCategory: 'Gosa filadhu',
  dashSubcategory: 'Gosa xiqqaa',
  dashSelectSubcategory: 'Gosa xiqqaa filadhu',
  dashAvailableColors: 'Waan argadhu',
  dashColorsHint: "Qoftiwwan cuuqaafadhu — waan argadhu qofa filadhu.",
  dashAllColors: 'Waan jiran qofa',
  dashProductPhotos: 'Suuraawwan oomishaa',
  dashProductPhotosHint: 'Hangafamii 5. Isa tokkoon buufa.',
  dashUploadingPhotos: "Suuraawwan fe'aa jira...",
  dashStockLabel: (n) => `Kuusaa: ${n}`,
  dashPaymentMethods: 'Kaffaltiin bakka',
  dashPaymentMethodsDesc: 'Herregga baankii itti kaffaltu karaa isniifitii. Karaa kaffaltii irratti argama.',
  dashAddBankAccount: 'Herregga baankii dabalii',
  dashBankLabel: 'Baankii',
  dashAccountNumber: 'Lakkawwan herregaa',
  dashAccountNumberPh: 'Fakkeenya: 1000123456789',
  dashAccountNameOptional: "Maqaa herregaa (dhiisa ta'u)",
  dashAccountNamePh: 'Fakkeenya: Daldala Koo PLC',
  dashAddPaymentMethod: 'Herregga kuusi',
  dashYourAccounts: 'Herregaalee koo',
  dashNoBankAccounts: 'Kaffaltiin sifa amma hin dabalinne.',
  dashAccountLabel: (n) => `Herregga: ${n}`,
  dashStatusPending: 'Madaallii keessa jira',
  dashStatusActive: 'Mirkaneessee',
  dashStatusSuspended: 'Dhaabbate',
  dashOrderStatusPending: 'Kaffaltii eegaa jira',
  dashOrderStatusConfirmed: 'Mirkaneessee',
  dashOrderStatusRejected: 'Diddee',
  dashStatusUnknown: (s) => s,
};

